import { useState, useCallback } from 'react';

export const useUncontrolledInput = (
    initialValue?: string,
    changeHandler?: (value: string) => void
): [string, (value: string) => void] => {
    const [value, setValue] = useState(initialValue || '');

    const onChange = useCallback(
        (newValue: string) => {
            setValue(newValue);
            changeHandler?.(newValue);
        },
        [changeHandler, setValue]
    );

    return [value, onChange];
};
